import React from "react";
import { educations } from "../../data/EducationData";
import { ContactWrapper } from "../Contact/ContactElements";
import EducationCard from "./EducationCard/EducationCard";

const Education = () => {
  return (
    <>
      <ContactWrapper id="education">
        <div className="Container">
          <div className="SectionTitle">Education</div>
          {educations.map((exp, index) => (
            <div
              style={{
                marginBottom: "40px",
              }}
            >
              <EducationCard key={index} index={index} {...exp} />
            </div>
          ))}
        </div>
      </ContactWrapper>
    </>
  );
};

export default Education;
